module.exports = __webpack_public_path__ + "img/sus_combining_algorithms_and_human_checks.933d4204.png";